/** @format */

import React, { FunctionComponent, useState, useEffect, useRef } from 'react'
import Card from 'kpc-react/components/card'
import Intact from 'intact-react'
import { Button, ButtonGroup } from 'kpc-react/components/button'
import BaseChart from 'src/components/BaseChart'
import styled from 'styled-components'
import { GetAlertNumber } from 'src/api/ApiGeneral'
import { _$ } from 'kpc-react'
import { handleExportForm } from 'src/utils'

const Alarm: FunctionComponent<any> = ({ className }) => {
  const [currentTime, setCurrentTime] = useState(7)
  const [options, setOptions] = useState(undefined)
  const currentAlarmData = useRef([])
  const getAlarmCountData = async time => {
    const alertNumber = await GetAlertNumber(time)
    if (alertNumber?.code === 'Success') {
      const alertData = alertNumber?.data?.alertNumberList || []
      renderChart(alertData)
      currentAlarmData.current = alertData
    }
  }

  useEffect(() => {
    getAlarmCountData(currentTime)
  }, [currentTime])

  const renderChart = renderData => {
    const dataSet = renderData.map(i => ({
      name: i.productName,
      type: 'line',
      seriesLayoutBy: 'row',
      smooth: true,
      data: Object.values(i?.data)
    }))

    // 指定图表的配置项和数据
    const option = {
      tooltip: {
        trigger: 'axis'
      },
      grid: {
        left: '5%',
        right: '2%',
        top: '10%',
        bottom: '8%'
      },
      xAxis: {
        type: 'category',
        data: Object.keys(renderData[0]?.data || {})
      },
      yAxis: {
        type: 'value',
        minInterval: 1
      },
      series: dataSet
    }
    setOptions(option)
  }
  // 导出当前时间数据
  const exportAlarmCount = () => {
    // 导出列表headers
    const headers = [{ value: '时间', key: 'time' }].concat(
      currentAlarmData.current.map(item => ({
        key: item.productType,
        value: item.productName
      }))
    )
    const dataSource = []
    const times = Object.keys(currentAlarmData.current[0]?.data)
    // 生成导出数据列表内容
    times.forEach(el => {
      const currentProductCount = currentAlarmData.current.map(i => i?.data[el])
      const timeItem = [el].concat(currentProductCount)
      dataSource.push(timeItem)
    })
    // 公共方法，导出表格
    handleExportForm(headers, dataSource, _$('告警次数'))
  }
  return (
    <Card
      className={className}
      title={Intact.normalize(<h4>{_$('告警次数')}</h4>)}
      b-extra={<a onClick={() => exportAlarmCount()}>{_$('导出')}</a>}
    >
      <div style={{ height: '48px', lineHeight: '48px', textAlign: 'right' }}>
        <ButtonGroup
          checkType="radio"
          value={currentTime}
          on$change-value={(c, time) => {
            setCurrentTime(time)
          }}
        >
          <Button value={7}>{_$('近7天')}</Button>
          <Button value={15}>{_$('近15天')}</Button>
          <Button value={30}>{_$('近30天')}</Button>
        </ButtonGroup>
      </div>
      <div className="chart-content">
        <BaseChart options={options} />
      </div>
    </Card>
  )
}
export default styled(Alarm)`
  width: 65%;
  .k-body {
    height: 100%;
  }
  .chart-content {
    height: calc(100% - 90px);
  }
`
